import React from "react";
import CaracterizacaoEmpresa from "./_/containers/CaracterizacaoEmpresa";
import "./style.scss";
const Empresa = (props) => <CaracterizacaoEmpresa {...props} />;

export default Empresa;
